function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 1a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V3a2 2 0 012-2h5zM5 12l.005.102a1 1 0 00.892.893L6 13h5l.102-.005A1 1 0 0012 12V6H5v6zm2 0H6v-1h1v1zm2 0H8v-1h1v1zm2 0h-1V9h1v3zm-4-2H6V9h1v1zm2 0H8V9h1v1zM7 8H6V7h1v1zm2 0H8V7h1v1zm2 0h-1V7h1v1zM6 2a1 1 0 00-1 1v2h7V3a1 1 0 00-1-1H6z",
  fill: "currentColor"
}));